export const DEFAULT_BATCH_COUNTRY = 'USA';
export const BATCH_COUNTRY_UK = 'UK';
export const COUNTRY_LABELS = {
    'USA': 'USA',
    'UK' : 'UK',
    'DE': 'Germany',
    'IT': 'Italy',
    'ESP': 'Spain',
    'FR': 'France',
    'SRB': 'Serbia'
}